import { useNavigation } from "react-router";

import { cn } from "../lib/utils";

/** Thin bar at the top of the viewport while the router waits on loaders. */
export function NavigationProgress() {
  const isLoading = useNavigation().state !== "idle";

  return (
    <div
      role="progressbar"
      aria-label="Cargando"
      aria-hidden={!isLoading}
      className={cn(
        "pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden transition-opacity",
        // The delay keeps fast navigations from flashing the bar.
        isLoading ? "opacity-100 delay-150" : "opacity-0",
      )}
    >
      <div className="h-full w-1/3 animate-navigation-progress bg-primary" />
    </div>
  );
}
